import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country, Manager } from '../../../domain/data';
import { DocumentType, GetCountriesUseCase, Nature } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-manager',
    templateUrl: './full-data-form-manager.component.html',
    styleUrls: ['./full-data-form-manager.component.scss']
})
export class FullDataFormManagerComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public Nature: typeof Nature = Nature;
    public DocumentType: typeof DocumentType = DocumentType;

    public prefix: string;
    public countries: Country[] = [];

    @Input()
    manager: Manager;

    @Input()
    isDisabled = false;


    constructor(parentEvents: ParentEvents,
                private dialog: MatDialog,
                private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfman-${nextUniqueId++}-`;
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase.bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe(transaction => {
                if (transaction.isSuccess) {
                    this.countries = (transaction.data as Country[]);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onResize() {
        this.parentEvents.resize();
    }
}
